export default __webpack_public_path__ + "static/media/clarg.be11e355.jpg";